module.exports = __webpack_public_path__ + "static/media/halloween8.84202641.jpg";